import { browser } from '$app/environment';
import { page } from '$app/state';
import { deviceType } from '$lib/services/mediaQuery/screenSize';
import { getSearchParamsStore } from '$lib/services/urls/searchParams';
import * as m from '$paraglide/messages';
import { get } from 'svelte/store';

export function getStaticData() {
	if (!browser) return;

	const device = ['desktop', 'tablet'].includes(get(deviceType)) ? 'DESKTOP' : 'MOBILE';
	const searchParams = getSearchParamsStore();
	const selectedRoute = searchParams && (get(searchParams)?.selectedRoute ?? 0);
	const itineraryResultsStore = page.data.itineraryResultsStore && get(page.data.itineraryResultsStore);
	const departure = itineraryResultsStore?.departureAddress?.city || '';
	const arrival = itineraryResultsStore?.arrivalAddress?.city || '';
	const distance = itineraryResultsStore?.routes[selectedRoute]?.routeDistance.value;
	const cost
		= typeof distance === 'number' && !Number.isNaN(distance)
			? Math.round((distance) * 0.135)
			: 0;

	return {
		routeresults: [
			{
				type: 'TURO',
				priority: 4,
				adservingId: 'iti:turo',
				title: 'Location entre particuliers',
				description:
					'Louez une voiture sur Turo, la plus grande plateforme d’autopartage au monde.',
				nextDescription: '',
				highlight: '',
				nextHighlight: '',
				legalNotice: '',
				brandImage: {
					w160: 'https://bff.viamichelin.com/static/img/advertising/turo/card/brand-image_w160.webp',
					w320: 'https://bff.viamichelin.com/static/img/advertising/turo/card/brand-image_w320.webp',
					w640: 'https://bff.viamichelin.com/static/img/advertising/turo/card/brand-image_w640.webp',
					w960: 'https://bff.viamichelin.com/static/img/advertising/turo/card/brand-image_w960.webp',
					w1280:
						'https://bff.viamichelin.com/static/img/advertising/turo/card/brand-image_w1280.webp',
					w1920:
						'https://bff.viamichelin.com/static/img/advertising/turo/card/brand-image_w1920.webp',
				},
				contentImage: {
					w160: '',
					w320: '',
					w640: '',
					w960: '',
					w1280: '',
					w1920: '',
				},
				styles: {
					textColor: '#121214',
					backgroundColor: '#F9F9F9',
				},
				cta: {
					url: 'http://pubads.g.doubleclick.net/gampad/clk?id=4961556625&iu=/3513/via_int_1_1x1_resultiti',
					clickUrl:
						'http://pubads.g.doubleclick.net/gampad/clk?id=4961556625&iu=/3513/via_int_1_1x1_resultiti',
					impressionUrl:
						'https://pubads.g.doubleclick.net/gampad/ad?iu=/3513/via_int_1_1x1_resultiti/ouicar40171locataire&sz=1x1&c={{timestamp}}',
					label: 'Explorer',
					styles: {
						foregroundColors: {
							enabled: '#121214',
							hover: '#121214',
							focus: '#121214',
							pressed: '#121214',
						},
						backgroundColors: {
							enabled: '#F2E9FF',
							hover: '#F2E9FF',
							focus: '#F2E9FF',
							pressed: '#F2E9FF',
						},
						shadowColor: '#121214',
						borderRadius: 80,
					},
				},
			},
			{
				type: 'BLABLACAR',
				priority: 1,
				title: m.routeresults__blablacar_card__title({ departure, arrival }),
				description: m.routeresults__blablacar_card__description({ cost }),
				contentImage: {
					w160: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w160.webp',
					w320: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w320.webp',
					w640: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w640.webp',
					w960: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w960.webp',
					w1280:
						'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w1280.webp',
					w1920:
						'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w1920.webp',
				},
				legalNotice: m.routeresults__blablacar_card__legal_notice(),
				cta: {
					label: m.routeresults__blablacar_card__cta_label(),
					url: m.routeresults__blablacar_card__cta_url({ arrival, departure, device }),
					styles: {
						backgroundColors: {
							enabled: '#00AFF5',
							hover: '#00AFF5',
							focus: '#00AFF5',
							pressed: '#00AFF5',
						},
						foregroundColors: {
							enabled: '#FFFFFF',
							hover: '#FFFFFF',
							focus: '#FFFFFF',
							pressed: '#FFFFFF',
						},
						borderRadius: 80,
						shadowColor: '#054752',
					},
					clickUrl: '',
					impressionUrl: '',
				},
				brandImage: {
					w160: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w160.webp',
					w320: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w320.webp',
					w640: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w640.webp',
					w960: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w960.webp',
					w1280:
						'https://bff.viamicheling.com/static/img/advertising/blablacar/card/brand-image_w1280.webp',
					w1920:
						'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w1920.webp',
				},
				styles: {
					textColor: '#054752',
					backgroundColor: '#BDD4D7',
				},
			},
		],
		routecosts: [
			{
				type: 'BLABLACAR',
				priority: 1,
				title: m.routecosts__blablacar_card__title(),
				description: m.routecosts__blablacar_card__description(),
				contentImage: {
					w160: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w160.webp',
					w320: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w320.webp',
					w640: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w640.webp',
					w960: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w960.webp',
					w1280:
						'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w1280.webp',
					w1920:
						'https://bff.viamichelin.com/static/img/advertising/blablacar/card/content-image_w1920.webp',
				},
				legalNotice: m.routecosts__blablacar_card__legal_notice(),
				cta: {
					label: m.routecosts__blablacar_card__cta_label(),
					url: m.routecosts__blablacar_card__cta_url({ device }),
					styles: {
						backgroundColors: {
							enabled: '#00AFF5',
							hover: '#00AFF5',
							focus: '#00AFF5',
							pressed: '#00AFF5',
						},
						foregroundColors: {
							enabled: '#FFFFFF',
							hover: '#FFFFFF',
							focus: '#FFFFFF',
							pressed: '#FFFFFF',
						},
						borderRadius: 80,
						shadowColor: '#054752',
					},
					clickUrl: '',
					impressionUrl: '',
				},
				brandImage: {
					w160: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w160.webp',
					w320: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w320.webp',
					w640: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w640.webp',
					w960: 'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w960.webp',
					w1280:
						'https://bff.viamicheling.com/static/img/advertising/blablacar/card/brand-image_w1280.webp',
					w1920:
						'https://bff.viamichelin.com/static/img/advertising/blablacar/card/brand-image_w1920.webp',
				},
				styles: {
					textColor: '#054752',
					backgroundColor: '#BDD4D7',
				},
			},
		],
	};
}

export type StaticData = ReturnType<typeof getStaticData>;
